export const data = {


  Line: [
    {
      year: "Jan",
      range1: 90,
      range2: 30,
      range3: 70,
    },
    {
      year: "Feb",
       range1: 40,
      range2: 60,
      range3: 50,
    },
    {
      year: "Mar",
       range1: 80,
      range2: 60,
      range3: 40,
    },
    {
      year: "Apr",
      range1: 40,
      range2: 60,
      range3: 50,
    },
    {
      year: "May",
      range1: 50,
      range2: 30,
      range3: 70,
    },
    {
      year: "Jun",
      range1: 50,
      range2: 30,
      range3: 80,
    },
    {
      year: "Jul",
      range1: 40,
      range2: 60,
      range3: 50,
    },
    {
      year: "Aug",
      range1: 50,
      range2: 30,
      range3: 70,
    },
    {
      year: "Sep",
       range1: 50,
      range2: 80,
      range3: 40,
    },
    {
      year: "Oct",
      range1: 50,
      range2: 30,
      range3: 40,
    },
    {
      year: "Nov",
      range1: 90,
      range2: 60,
      range3: 50,
    },
    {
      year: "Dec",
      range1: 50,
      range2: 30,
      range3: 70,
    },
  ],


  labels: [
    {
      year: "Jan",
      range1: 7,
      range2: 5,
    },
    {
      year: "Feb",
      range1: 10,
      range2: 6,
    },
    {
      year: "Mar",
      range1: 11,
      range2: 8,
    },
    {
      year: "Apr",
      range1: 8,
      range2: 6,
    },
    {
      year: "May",
      range1: 7,
      range2: 5,
    },
    {
      year: "Jun",
      range1: 7,
      range2: 4,
    },
    {
      year: "Jul",
      range1: 7,
      range2: 6,
    },
    {
      year: "Aug",
      range1: 7,
      range2: 5,
    },
    {
      year: "Sep",
      range1: 7,
      range2: 6,
    },
    {
      year: "Oct",
      range1: 7,
      range2: 5,
    },
    {
      year: "Nov",
      range1: 7,
      range2: 4,
    },
    {
      year: "Dec",
      range1: 7,
      range2: 6,
    },
  ],
};
